import styled from 'styled-components'
import { Fonts } from 'components/base-ui'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  min-height: 100%;
  padding: 16px;
`

const Header = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  width: 100%;
  padding-bottom: 16px;
  background: ${({ theme }) => theme.colors.white};
`

const Description = styled(Fonts.BaseTitleRegular)`
  color: ${({ theme }) => theme.colors.darkGrey};
`

const CouponListSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: 120px;
`

const CouponItemWrapper = styled.div<{ borderTop: boolean }>`
  padding: 8px 0;
  border-top: ${({ borderTop }) => (borderTop ? '1px solid #eeeeee' : 'none')};
`

const ShareButtonWrapper = styled.div`
  position: fixed;
  margin-left: auto;
  margin-right: auto;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 12px;
  width: 100%;
  padding: 16px 0;
`

export { Wrapper, Header, Description, CouponListSection, CouponItemWrapper, ShareButtonWrapper }
